import { Component } from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import '@/components/tableStyle/index.less'
import { CustomerApplicationServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import { cloneDeep } from 'lodash'
import dayjs from 'dayjs'
import '../bind-apply/index.less'

const api = new CustomerApplicationServiceProxy()

@Component
export default class CreateApply extends Template {
  name = '新建申请'

  dialogVisible = false; // 拒绝dialog
  refuseForm = {
    comment: null, // 理由
  }
  rowId: '' // 单个删除

  options = {
    retrieve: api.page.bind(api),
    search: null,
    create: null,
    update: null,
    delete: null
  }
  acl = {
    create: 'page_create_apply_fast',
    delete: 'page_create_apply_refuse'
  }

  params = {
    statusList: [1, 2, 3]
  }

  scroll = {}

  get lang() {
    return {
      create: this.$t('page_create_apply_fast'),
      placeholder: this.$t('keyword'),
      search: this.$t('search'),
      delete: this.$t('page_create_apply_refuse')
    }
  }

  get statusList() {
    return [
      { label: this.$t('page_control_handle'), value: 1, color: 'orange' },// 待处理
      { label: this.$t('page_create_apply_created'), value: 2, color: 'green' },//已创建
      { label: this.$t('page_bind_apply_refused'), value: 3, color: 'red' }//已拒绝
    ]
  }

  render() {
    return this.customRender()
  }

  get columns() {
    return [
      {
        title: this.$t('page_batch_management_action'),
        key: 'action',
        width: 120,
        customRender: (row, record) => {
          return record.status === 1 ? (
            <div>
              <a-popconfirm
                disabled={!this.getAcl(this.acl.create)}
                title={this.$t('page_create_apply_fastly')}
                onConfirm={() => this.fastCreate(record)}
                okText={this.$t('yes')}
                cancelText={this.$t('no')}
              >
              <a
                type="link"
                onClick={(e) => {
                  e.stopPropagation()
                }}
              >
                {this.lang.create}
              </a>
              </a-popconfirm>
              <a-divider type="vertical"/>
                <a
                  type="link"
                  disabled={!this.getAcl(this.acl.delete)}
                  onClick={()=>{this.dialogVisible= true; this.rowId = record.id;}}
                  class="del-color"
                >
                  {this.lang.delete}
                </a>
            </div>
          ): '-'
        }
      },
      { title: this.$t('page_ops_work_record_document_number'), dataIndex: 'code', width: 130 },// 单据号
      { title: this.$t('page_ops_work_record_contact_person'), dataIndex: 'contact', width: 80 },// 上报人
      { title: this.$t('page_ops_work_record_contact_information'), dataIndex: 'tel', width: 120 }, // 联系方式
      {
        title: this.$t('page_extranet_Submit_time'), dataIndex: 'createTime', width: 150, // 提交时间
        customRender: (time) => {
          return time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : '-'
        }
      },
      { title: this.$t('page_suolide_customer_name'), dataIndex: 'name', width: 150 }, // 客户名称
      { title: this.$t('page_ops_customer_province'), dataIndex: 'provinceName', width: 80 },//省份
      { title: this.$t('page_ops_customer_detailed_address'), dataIndex: 'address', width: 200 },//详细地址
      { title: this.$t('page_standard_process_equipment_model'), dataIndex: 'deviceTypeName' },// 设备型号
      { title: this.$t('page_ops_machine_machine_serialNo'), dataIndex: 'serialNo' }, // 设备序列号
      {
        title: this.$t('page_ops_work_record_record_status'), dataIndex: 'status', // 记录状态
        customRender: (val) => {
          const status = this.statusList.find(item => item.value === Number(val))
          return status ? (
            <a-tag color={status.color}>
              {status.label}
            </a-tag>
          ): null
        }
      }
    ]
  }

  created() {
    let table: any = document.getElementsByClassName('temp-table-con')
    let height = 300
    if (table) {
      height = table.clientHeight - 40
    }
    this.scroll = { y: height }
  }

  getCheckboxProps(record) {
    return ({
      style: {
        display: record.id ? 'block' : 'none'
      },
      props: {
        disabled: record.status && record.status > 1
      }
    })
  }

  async getData(
    current = this.filters.current,
    size = this.filters.size,
    keyWords = this.keywords,
    reload: any = false
  ) {
    this.loading = true
    if (reload) current = 1
    const fetchFn = this.options.retrieve.bind(this)
    const { records, total: t, size: s, current: c } = await fetchFn(
      current,
      {
        keyWord: keyWords,
        statusList: this.params.statusList
      },
      size
    )
    this.loading = false


  /*  let dataLength = records.length
    let copy = cloneDeep(records)
    let needPush = 0
    if (dataLength < 30) {
      needPush = 30 - dataLength
      for (var k = 0; k < needPush; k++) {
        let obj = {
          // id: 'none'
        }
        copy.push(obj)
      }*/
      // todo
      this.dataSource = cloneDeep(records)


      this.filters = {
        total: Number(t),
        size: Number(s),
        current: Number(c)
      }
    // }
  }

  inputStatus(value) {
    const newTags = [...this.params.statusList]
    const status = this.params.statusList.find((res) => res == value)
    if (!status) {
      this.params.statusList.push(value)
    } else {
      this.params.statusList = newTags.filter((res) => res != value)
    }
    this.filters.size = 30
    this.filters.current = 1
    this.getData()
  }

  // 快速创建
  async fastCreate(row?) {
    const id = row && row.id ? row.id : this.selectedRowKeys
    await api.process({id: id, status: 2} as any)
    this.$message.success(this.$t('page_resource_pool_success'))
    this.getData()
  }

  // 拒绝
  async handleRefuse() {
    if(!this.refuseForm.comment) {
      return this.$message.warning(this.$t('common_please_input'));
    }
    await api.process({comment: this.refuseForm.comment, id: this.rowId, status: 3} as any)
    this.dialogVisible = false;
    this.$message.success(this.$t('page_resource_pool_success'))
    this.getData()
  }
  onClose() {
    this.dialogVisible = false;
    this.refuseForm.comment = '';
  };
  renderDialog() {
    return (
      <a-modal
        class={this.templateModalClass}
        title={this.$t('page_refuse_reason')}
        visible={this.dialogVisible}
        destroyOnClose={true}
        maskClosable={false}
        onCancel={this.onClose}
        onOk={this.handleRefuse}
      >
        <a-form-model
          ref="ruleForm"
          props={{ model: this.refuseForm }}
          label-col={{ span: 6 }}
          wrapper-col={{ span: 16 }}
        >
          <a-form-model-item label={this.$t('page_refuse_reason')}>
             <a-textarea vModel={this.refuseForm.comment} placeholder={this.$t('common_please_input')} rows="4" maxLength={128} />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    )
  }

  renderHeader(slot = null) {
    const filter = (
      <div class="flex status-choose mg-r8">
        <div class="flex status-choose state-filter">
          <div class="label">{this.$t('page_ops_work_record_filter') + '：'}</div>

          {this.statusList.map(status => (
            <div key={status.value}>
              {this.params.statusList.includes(status.value) ? <a-tag
                  color={status.color}
                  onClick={() => this.inputStatus(status.value)}
                >
                  {status.label}
                </a-tag> :
                <a-tag
                  style="background: #fff; border-style: dashed"
                  onClick={() => this.inputStatus(status.value)}
                >
                  {status.label}
                </a-tag>}
            </div>))}

        </div>
      </div>
    )

    return (
      <div
        slot="action"
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <div></div>
        {this.showSearch ? (<div style="display:flex;align-items:center">
          {filter}
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
          ></a-input-search>
        </div>) : null}
      </div>
    )
  }

}